// The homepage switch never publishes products or changes inventory.
export function resolveSeason({ enabled, preview, mode, launch, now = Date.now() }) {
  if (preview && (mode === 'before' || mode === 'after')) return mode;
  const deadline = Date.parse(launch);
  return enabled && Number.isFinite(deadline) && now >= deadline ? 'after' : 'before';
}

if (typeof customElements !== 'undefined' && !customElements.get('bhc-season-schedule')) {
  customElements.define('bhc-season-schedule', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.update = this.update.bind(this);
      document.addEventListener('visibilitychange', this.update, { signal: this.controller.signal });
      this.update();
    }
    update() {
      clearTimeout(this.timer);
      const state = resolveSeason({
        enabled: this.dataset.enabled === 'true',
        preview: this.dataset.preview === 'true',
        mode: this.dataset.mode,
        launch: this.dataset.launch
      });
      document.documentElement.dataset.bhcSeason = state;
      // Stop media in the inactive hero. Hidden Christmas video is never loaded.
      const inactive = state === 'before' ? 'christmas_hero' : 'hero';
      document.getElementById(`shopify-section-${this.dataset.prefix}__${inactive}`)
        ?.querySelectorAll('video').forEach(video => video.pause());
      if (this.dataset.enabled === 'true' && this.dataset.mode === 'automatic' && state === 'before') {
        const remaining = Date.parse(this.dataset.launch) - Date.now();
        if (Number.isFinite(remaining) && remaining > 0) {
          this.timer = setTimeout(this.update, Math.min(remaining + 20, 60000));
        }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
  });
}
